import React from 'react';
import { BuyToken } from '../ui/buy-token';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import Countdown from './Countdown';
import Link from 'next/link';

const HeroSection = () => {
  const { t } = useTranslation();
  return (
    <div className=" min-h-[2735px] xl:min-h-[1100px] pt-[147px] xl:pt-[200px] relative z-[4]">
      <Image
        width={1000}
        height={1000}
        src="/assets/Baclground 1 back 2-min.png"
        className="absolute object-cover top-0 w-full h-full z-[-1] hidden md:block"
        alt=""
      />
      <Image
        width={1000}
        height={1000}
        priority
        src="/assets/Group 1597885921.png"
        className="absolute object-cover top-0 w-full h-full z-[-1]  md:hidden"
        alt=""
      />

      <img
        src="/gif/roadmap.gif"
        alt="Roadmap GIF"
        width="1000"
        height="1000"
        className="w-auto lg:hidden max-w-[300px] md:max-w-[450px] largeScreen:max-w-[547px] h-auto absolute right-16 lg:right-[20%] bottom-[-23px] md:bottom-[0%] lg:bottom-16 largeScreen:bottom-0"
      />

      <Image
        width={1000}
        height={1000}
        src="/assets/hero1.png"
        className="w-auto lg:hidden max-w-[200px] md:max-w-[300px] largeScreen:max-w-[464px] h-auto absolute right-12 lg:right-[18%] largeScreen:right-[16%] bottom-[4%] lg:bottom-[23%] largeScreen:bottom-[20%]"
        alt="Roadmap GIF"
      />

      {/* <Image
        width={1000}
        height={1000}
        src="/assets/IMG_0971.png"
        className="absolute lg:block hidden   xl:h-[388px] max-w-[302px] w-full bottom-[0]   right-[-30px]"
        alt=""
      /> */}
      {/* <Image
        width={1000}
        height={1000}
        src="/assets/IMG_1923.png"
        className="absolute max-w-[800px] largeScreen:max-w-[1041px] w-full h-auto right-[-60px] xl:right-0 bottom-32 mediumScreen:bottom-0"
        alt=""
      /> */}
      <Image
        width={1000}
        height={1000}
        src="/assets/IMG_0969 1.svg"
        className="absolute hidden lg:block max-sm:max-w-[231px] max-lg:max-w-[252px] max-largeScreen:max-w-[336px] xl:hidden md:left-8 max-w-[425px] w-full max-md:bottom-[101px] bottom-[60px] xl:bottom-[110px] z-[0] max-xxs:left-[-20px] max-lg:left-0 largeScreen:right-[30%]"
        alt=""
      />

      {/* <Image
        width={1000}
        height={1000}
        src="/assets/IMG_0969 2.png"
        className="absolute  xl:block hidden right-[32%] largeScreen:right-[40%] max-w-[380px] largeScreen:max-w-[425px] w-full bottom-[60px] xl:bottom-[27%] mediumScreen:bottom-[20%] z-[2] "
        alt=""
      /> */}
      <Image
        width={1000}
        height={1000}
        src="/assets/small monster 1.svg"
        className="absolute max-lg:max-w-[28px] max-w-[47px] w-full max-md:bottom-[72px] bottom-14 max-xl:left-3 left-[44%] xl:bottom-[162px] z-[2]  "
        alt=""
      />

      <img
        width={1000}
        height={1000}
        src="/assets/alien-dance3.png"
        className="absolute max-w-[161px] max-lg:max-w-[100.515869140625px] bottom-10 xl:bottom-[1.5rem] max-lg:right-0  xl:left-[43%]  largeScreen:left-[48%]   "
        alt=""
      />

      <img src="/assets/bush 2.svg" className="absolute bottom-[10%] xl:bottom-[-80px] left-0 z-[-1]" alt="" />
      <div className="max-w-[1663px] largeScreen:px-4 px-16 xl:flex-row flex-col-reverse gap-[68px] xl:gap-0 mx-auto max-lg:px-4 w-full flex justify-between items-start">
        <div className="hidden xl:block">
          <BuyToken />
        </div>
        <div className="flex flex-col xl:mt-[-40px] max-lg:items-center max-xl:max-w-[500px] xl:max-w-[650px]   largeScreen:max-w-[850px] largeScreen:ml-auto w-full ">
          <h1 className=" text-[44.9px] max-lg:max-w-[344px] w-full mx-auto max-lg:leading-[94%] xl:text-[48px] font-normal font-koulen text-white text-center ">
            {t('LAYERBRETTISUNLEASHING')}
          </h1>
          <img src="/assets/future.svg" className="hidden xl:block" alt="" />
          <img src="/assets/fututrMob.svg" alt="" className="lg:hidden" />
          <div className="pt-10 pb-[65px] xl:hidden">
            <BuyToken />
          </div>
          {/* <Countdown /> */}
          <div className="max-w-[452px] py-6 w-full mx-auto">
            <Link href={'/testnet'}>
              <button className="w-full flex leading-[80%] font-normal font-koulen text-[25.48px] text-[#D6FF00] justify-center items-center h-[67px] bg-[#0487AB] border-2 border-[#D6FF00] shadow-yellowShadow rounded-[5px] gap-4">
                <img src="/assets/Group 1597886063.png" alt="" />
                TRY TESTNET NOW
              </button>
            </Link>
          </div>
          <div className="grid max-w-[629px] w-full mx-auto gap-y-5 pt-[50px] lg:pt-4 grid-cols-2 xl:grid-cols-3  place-items-center">
            {[
              { bg: '/gif/roadmap.gif', icon: '/assets/Group 1597885912.png', label: '/assets/Layer 2.png' },
              { bg: '/gif/roadmap.gif', icon: '/assets/Group 1597885911.png', label: '/assets/Explorer.png' },
              { bg: '/gif/roadmap.gif', icon: '/assets/Group 1597885910.png', label: '/assets/Bridge.png' },
              { bg: '/gif/roadmap.gif', icon: '/assets/Group 1597885913.png', label: '/assets/Governance.png' },
              { bg: '/gif/roadmap.gif', icon: '/assets/Group 1597885909 (1).png', label: '/assets/question.png' },
              { bg: '/gif/roadmap.gif', icon: '/assets/Group 1597885908.png', label: '/assets/question.png' },
            ].map((item, i) => (
              <div key={i} className="relative w-full h-full flex flex-col items-center justify-center mx-auto">
                {/* GIF behind everything */}
                <img
                  src={item.bg}
                  alt=""
                  className="absolute inset-0 m-auto w-[230px] h-[230px] object-cover z-0 pointer-events-none"
                />

                {/* Foreground content */}
                <div className="relative z-10 flex flex-col items-center justify-center gap-3">
                  {/* Icon (bigger now) */}
                  <img src={item.icon} alt="" className="block w-auto max-w-[160px] max-h-[110px] object-contain" />

                  {/* Label text image (bigger now, consistent height) */}
                  <img src={item.label} alt="" className="block w-auto max-w-[170px] max-h-[38px] object-contain" />
                </div>
              </div>
            ))}
          </div>

          {/* <div className="flex justify-center w-full max-lg:pt-5 ">
            {[
              { bg: '/gif/roadmap.gif', icon: '/assets/Group 1597885909.png', label: '/assets/question.png' },
              { bg: '/gif/roadmap.gif', icon: '/assets/Group 1597885909.png', label: '/assets/question.png' },
            ].map((item, i) => (
              <div
                key={i}
                className="relative w-full lg:w-[260px] lg:h-[260px] flex flex-col items-center justify-center"
              >
              
                <img
                  src={item.bg}
                  alt=""
                  className="absolute inset-0 m-auto w-[230px] h-[230px] object-cover z-0 pointer-events-none"
                />
 
                <div className="relative z-10 flex flex-col items-center justify-center gap-3">
                  <img src={item.icon} alt="" className="block w-auto max-w-[160px] max-h-[110px] object-contain" />

                  <img src={item.label} alt="" className="block w-auto max-w-[170px] max-h-[38px] object-contain" />
                </div>
              </div>
            ))}
          </div> */}

          <div className=" flex xl:hidden justify-between flex-col lg:flex-row gap-6 lg:gap-0 items-center pt-5">
            <h2 className="text-[28.23px] borderShadow max-lg:text-center font-nunito font-[900] leading-[120%]">
              Join LayerBrett's Rapidly <br /> Growing Community Today!
            </h2>
            <div className="flex gap-3 items-center">
              <Link
                href={'https://x.com/LayerBrett'}
                target="_blank"
                className="w-[51.877418518066406px]  h-[51.877418518066406px] rounded-[8.04px] bg-[#FFB3E8] border-[2.41px] border-[#EF53C0C0] shadow-social flex items-center justify-center "
                aria-label="Twitter link"
              >
                <img src="/assets/xCom.png" alt="" />
              </Link>
              <Link
                href={'https://t.me/layerbrett'}
                target="_blank"
                aria-label="Telegram link"
                className="w-[51.877418518066406px]  h-[51.877418518066406px] rounded-[8.04px] bg-[#FFB3E8] border-[2.41px] border-[#EF53C0C0] shadow-social flex items-center justify-center "
              >
                <img src="/assets/teleg.png" alt="" />
              </Link>

              <Link
                href={'https://www.tiktok.com/@layerbrettofficial'}
                target="_blank"
                className="w-[51.877418518066406px]  h-[51.877418518066406px] rounded-[8.04px] bg-[#FFB3E8] border-[2.41px] border-[#EF53C0C0] shadow-social flex items-center justify-center "
              >
                <img src="/assets/tik-tok.png" alt="" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
